import { createSlice } from "@reduxjs/toolkit";

const UserSlicer = createSlice({
    name:'User',
    initialState:{
        loggedInUser:null,
    },
    reducers:{
        setLoggedInUser:(state,action)=>{
            state.loggedInUser = action.payload
        },
        logoutUser: (state) => {
            state.loggedInUser = null; 
        }
    }
})

export const {setLoggedInUser, logoutUser} = UserSlicer.actions;

export default UserSlicer.reducer;